import React from 'react';
import styles from './NavMenuButton.module.scss';
import classnames from 'classnames';
import Link from 'next/link';

export interface NavMenuButtonProps {
  href: string;
  openMenu: (name: string) => void;
  closeMenu: () => void;
  activeMenu: string;
  children: React.ReactNode;
  isWhite?: boolean;
  name: string;
}

export const NavMenuButton = ({
  href,
  name,
  openMenu,
  closeMenu,
  activeMenu,
  children,
  isWhite,
}: NavMenuButtonProps) => {
  return (
    <Link href={href}>
      <a
        className={classnames(
          styles.mainButton,
          activeMenu === name && styles.active,
          isWhite && styles.white
        )}
        onMouseEnter={() => openMenu(name)}
        onMouseLeave={() => closeMenu()}>
        {children}
        <div className={styles.mainButtonHoverEffect} />
      </a>
    </Link>
  );
};
